<template>
  <Select v-model="selected" @on-select="handleSelect" :clearable="clearable" :placeholder="$t('order.product_stage_select_placeholder')">
    <Option v-for="p in productStages" :key="p.value" :value="p.value">{{ p.label }}</Option>
  </Select>
</template>

<script>
export default {
  name: 'ProductPhaseSelect',
  props: {
    clearable: Boolean
  },
  data () {
    return {
      selected: this.$attrs.value,
      productStages: [
        { value: 'prototype', label: 'Prototype / 打样' },
        { value: 'pilot_run', label: 'Pilot run / 中试' },
        { value: 'ramp_up', label: 'Ramp up / 小批量' },
        { value: 'volume_production', label: 'Volume production / 批量' },
        { value: 'scm', label: 'SCM' }
      ]
    }
  },
  methods: {
    handleSelect (item) {
      this.$emit('input', item.value)
    }
  }
}
</script>
